import Vue from "vue";

function updateHeight(el, plus) {
	el.style.height = (window.innerHeight +  plus - el.getBoundingClientRect().y) + "px";
	el.style["overflow-y"] = "auto";
}

Vue.directive("from-here-to-end", {
	inserted(el, {value}) {
		let plus = value || 0;
		updateHeight(el, plus);
	},
	update(el, {value}) {
		let plus = value || 0;
		updateHeight(el, plus);
	},


});
